// extracted by mini-css-extract-plugin
export default {"settingPanelHeightToAuto":"publishing-panel-header-module__settingPanelHeightToAuto--aill9","shadowOnScroll":"publishing-panel-header-module__shadowOnScroll--UvMGb"};